module.exports = __webpack_public_path__ + "media/44.2bd927b1.wav";